import {
  getGetFrontRichiesteIdModuliIdQueryKey,
  getGetFrontRichiesteIdModuliQueryKey,
  usePostFrontRichiesteIdModuliIdStato,
} from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type EnumCambiamentoStatoRequestTransizione } from '@framework/api-client/api/inquiries-compile/schemas/enumCambiamentoStatoRequestTransizione.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { type IModuleStateMachineRecord } from '@framework/frontoffice-submission/module/fsm/ModuleStateMachine.ts';
import { message } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { queryClient } from '../../../../../core/network/queryClient.ts';

/**
 * Ritorna la funzione utile a cambiare lo stato di un modulo di una submission.
 */
export function useSubmissionModuleStateChanger(params: {
  data: IModuleStateMachineRecord;
  /** Se non fornito, non mostra il messaggio */
  successMessage: string | null;
}) {
  const { data, successMessage } = params;
  const { t } = useTranslation();

  const stateChanger = usePostFrontRichiesteIdModuliIdStato();
  const submissionModuleId = data.module?.moduloRichiestaId;
  const submissionId = data.submission?.id;

  const handleClick = useCallback(
    async (
      toState: EnumCambiamentoStatoRequestTransizione,
      options?: {
        /** Se true, le query non vengono invalidate dopo il passaggio di stato */
        mantainQueries?: boolean;
      },
    ) => {
      if (!submissionModuleId) return;
      if (!submissionId) return;

      try {
        await stateChanger.mutateAsync({
          id: submissionId,
          idRichiestaModulo: submissionModuleId,
          data: {
            transizione: toState,
          },
        });
        if (!options?.mantainQueries) {
          await queryClient.invalidateQueries(
            getGetFrontRichiesteIdModuliIdQueryKey(
              submissionId,
              submissionModuleId,
            ),
          );

          await queryClient.invalidateQueries(
            getGetFrontRichiesteIdModuliQueryKey(submissionId),
          );
        }

        successMessage && message.success(successMessage);
      } catch (e) {
        console.error(`[ReadyToSignButton] Error while changing state`, e);
        // biome-ignore format: <tbd>
        message.error(getNetworkErrorMessage(e, t('submission-action-button.errore', `Si è verificato un errore: riprovare`)));
      }
    },
    [submissionModuleId, submissionId, stateChanger, successMessage, t],
  );

  return {
    handleClick,
  };
}
